import { render, staticRenderFns } from "./agent-marketplace.vue?vue&type=template&id=410f8e88&scoped=true"
import script from "./agent-marketplace.vue?vue&type=script&lang=js"
export * from "./agent-marketplace.vue?vue&type=script&lang=js"
import style0 from "./agent-marketplace.vue?vue&type=style&index=0&id=410f8e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410f8e88",
  null
  
)

export default component.exports